export default "__VITE_ASSET__50af7006__"